import styled from 'styled-components';

const ReviewCard = styled.div`
  padding: ${({ theme }) => theme.spacing(1, 0, 4, 0)};
  color: ${({ theme }) => theme.colors.textPrimary};
  word-break: break-word;
  line-height: 1.33;
`;

export default ReviewCard;
